import Url from '../global/Url';

/**
 * Registra en la base de leads un número que llegó por la plataforma externa.
 * Sin esto, validar-base nunca lo encuentra y el lead se asigna sin datos.
 *
 * Ya no lleva token: era visible en el bundle y no protegía nada. La autorización
 * es responsabilidad del servidor.
 */
async function postLeadExterno(Lead) {
    try {
        const response = await fetch(Url.Api + 'leadExterno', {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify(Lead),
        });
        return await response.json();
    } catch (error) {
        console.error(`ERROR REGISTRO LEAD EXTERNO: ${error}`);
        return { header: 'ERROR', message: 'No se pudo conectar con el servidor' };
    }
}

export { postLeadExterno };
